// ----------------------------------------------------------------------

import { paramsToQueryKey } from '@/shared/lib/react-query';

import type { FetchInnsParams } from './inn.api';

const PREFIX = 'inn' as const;

// ----------------------------------------------------------------------

export const InnQueryKeys = {
  root: [PREFIX],

  inn: (params?: FetchInnsParams) => paramsToQueryKey([PREFIX, 'list'], params),
};
